<template>
  <v-toolbar app height="64">
    <v-layout align-center>
      <!-- logo -->
      <a href="https://kontinentalist.com/">
        <img
          src="@/assets/img/logo.svg"
          alt="kontinentalist-logo"
          width="40px">
      </a>

      <v-spacer/>

      <!-- social sharing -->
      <v-toolbar-items>
        <AppButtonSocialFacebook />

        <AppButtonSocialTwitter />

        <AppButtonSocialCopy />

      </v-toolbar-items>
    </v-layout>
  </v-toolbar>
</template>

<script>
import AppButtonSocialFacebook from '@/components/ui/AppButtonSocialFacebook.vue';
import AppButtonSocialTwitter from '@/components/ui/AppButtonSocialTwitter.vue';
import AppButtonSocialCopy from '@/components/ui/AppButtonSocialCopy.vue';

export default {
  name: 'TheNavbar',
  components: {
    AppButtonSocialFacebook,
    AppButtonSocialTwitter,
    AppButtonSocialCopy,
  },
};
</script>
